import React, { Component } from "react";

class MembersFormRow extends Component {
  handleChangeStatus = event => {
    let newState = this.props.pushtoken.state ? 0 : 1;
    console.log("Nieuwe status: " + newState);
    this.props.callbackUpdate({
      token: this.props.pushtoken.token,
      state: newState
    });
  };
  handleChangeVortex = event => {
    let newState = this.props.pushtoken.isVortex ? 0 : 1;
    console.log("Nieuwe status Vortex: " + newState);
    this.props.callbackVortexUpdate({
      token: this.props.pushtoken.token,
      state: newState
    });
  };
  deletePushToken = event => {
    console.log("Pushtoken to delete: " + this.props.pushtoken.token);
    fetch("/deleteMember", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        pushtoken: this.props.pushtoken.token
      })
    }).then(this.props.callbackUpdateTable());
  };

  handleChangeComment(event) {
    console.log(event);
    console.log(event.target.value);
    console.log(this.state)

      this.setState({ comment: event.target.value });
      console.log(
        "Current message: " +
          this.state.comment +
          " current user " +
          this.props.user
      );
  }

  handleSubmitComment(event) {
    console.log("Push Update to Server");
    console.log("Message: " + this.state.comment);

    return null;
    fetch("/send-message", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ comment: this.state.comment, user: this.props.user })
    });
  }

  render() {
    let datestring = new Date(this.props.pushtoken.timestamp)
      .toLocaleString("en-GB", {
        timeZone: "UTC"
      })
      .split(",");

    return (
      <tr>
        <td>{this.props.index}.</td>
        <td align="center">
          <input
            className="form-check-input"
            type="checkbox"
            checked={this.props.pushtoken.state}
            id={"status"+this.props.pushtoken.token}
            key={this.props.pushtoken.token}
            onChange={() =>
              this.handleChangeStatus({
                pusthoken: this.props.pushtoken.token
              })
            }
          />
          {this.props.pushtoken.state ? (
            <span className="badge badge-success" key={this.props.pushtoken.token}>Active</span>
          ) : (
            <span className="badge badge-secondary ml-2" key={this.props.pushtoken.token}>Not Active</span>
          )}
        </td>
        <td align="center">
          <input
            className="form-check-input"
            type="checkbox"
            checked={this.props.pushtoken.isVortex}
            id={"isVortex"+this.props.pushtoken}
            key={this.props.pushtoken}
            onChange={() =>
              this.handleChangeVortex({
                pusthoken: this.props.pushtoken.token
              })
            }
          />
        </td>
        <td>{datestring[0]}</td>
        <td>
          {this.props.pushtoken.receivePush ? (
            <span className="badge badge-success" key={this.props.pushtoken.token}>Active</span>
          ) : (
            <span className="badge badge-secondary ml-2" key={this.props.pushtoken.token}>Not Active</span>
          )}
        </td>
        <td>{this.props.pushtoken.token}</td>
        <td>{this.props.pushtoken.name}</td>
        <td>
              <input type="text" 
                  className="form-control"
                  key={"inputcomment"+this.props.pushtoken.token}
                  id={"inputcomment"+this.props.pushtoken.token}
                  size="40"
                  value={this.props.comment}
                  onBlur={() =>
                    this.handleSubmitComment({
                      pushtoken: this.props.pushtoken.token
                    })
                  }
                  onChange={() =>{
                    console.log("Handling the onchange")

                    this.handleChangeComment({
                    })}
                  }
                />
        </td>
        <td>
          <a href="#">
            <span
              className="oi oi-trash"
              id={"delete"+this.props.pushtoken}
              key={this.props.pushtoken.token}
              onClick={() =>
                this.deletePushToken({
                  pushtoken: this.props.pushtoken.token
                })
              }
            ></span>
          </a>
        </td>
      </tr>
    );
  }
}

export default MembersFormRow;
